import { type UrlBuilder } from '@webapp/hooks/useAppRoutes/types'
import { BillListPageStatuses } from '@webapp/pages/BillListPage'
import { NEW_BILL_QUERY_PARAM, NEW_BILL_QUERY_VALUE } from '../constants'

// The URL entry points link to when they should open the upload modal.
export const getNewBillModalUrl = (url: UrlBuilder) =>
  `${url('BillListPage', {
    status: BillListPageStatuses.DRAFT,
  })}?${NEW_BILL_QUERY_PARAM}=${NEW_BILL_QUERY_VALUE}`
